export enum BannerEvent {
  BANNER_CTA_CLICK = "BannerCtaClickEvent",
  SUBBANNER_CTA_CLICK = "SubBannerCtaClickEvent",
  BANNER_MORE_INFO_CTA_CLICK = "MoreInfoCtaClickEvent",
}
